// TEXT
//*******************************************************************
import React from 'react'
import '../styles/global.css'
import '../styles/TextBlock.css'
import '../styles/style.css'
//*******************************************************************
export default function TextBlock(props) {
    return (
        
        <div class="container">
            
            <div class="row">
        
                <div class={props.elementClass} id={props.id}>
        
                    <div class={props.dangerousClass} dangerouslySetInnerHTML={{ __html: props.text }} />
        
                </div>
        
            </div>
            
        </div>
        
    );
}
//*******************************************************************